export const initialState = {
  gallery: {
    data: [],
  },
  datepicker: {
    date: new Date(),
    time: "8:00 - 9:00",
  },
};
